import { Vector3 } from "three";

const DIRECTIONS = [
    0.000000, -1.000000, 0.000000,
    0.723607, -0.447220, 0.525725,
    -0.276388, -0.447220, 0.850649,
    -0.894426, -0.447216, 0.000000,
    -0.276388, -0.447220, -0.850649,
    0.723607, -0.447220, -0.525725,
    0.276388, 0.447220, 0.850649,
    -0.723607, 0.447220, 0.525725,
    -0.723607, 0.447220, -0.525725,
    0.276388, 0.447220, -0.850649,
    0.894426, 0.447216, 0.000000,
    0.000000, 1.000000, 0.000000,
    -0.162456, -0.850654, 0.499995,
    0.425323, -0.850654, 0.309011,
    0.262869, -0.525738, 0.809012,
    0.850648, -0.525736, 0.000000,
    0.425323, -0.850654, -0.309011,
    -0.525730, -0.850652, 0.000000,
    -0.688189, -0.525736, 0.499997,
    -0.162456, -0.850654, -0.499995,
    -0.688189, -0.525736, -0.499997,
    0.262869, -0.525738, -0.809012,
    0.951058, 0.000000, 0.309013,
    0.951058, 0.000000, -0.309013,
    0.000000, 0.000000, 1.000000,
    0.587786, 0.000000, 0.809017,
    -0.951058, 0.000000, 0.309013,
    -0.587786, 0.000000, 0.809017,
    -0.587786, 0.000000, -0.809017,
    -0.951058, 0.000000, -0.309013,
    0.587786, 0.000000, -0.809017,
    0.000000, 0.000000, -1.000000,
    0.688189, 0.525736, 0.499997,
    -0.262869, 0.525738, 0.809012,
    -0.850648, 0.525736, 0.000000,
    -0.262869, 0.525738, -0.809012,
    0.688189, 0.525736, -0.499997,
    0.162456, 0.850654, 0.499995,
    0.525730, 0.850652, 0.000000,
    -0.425323, 0.850654, 0.309011,
    -0.425323, 0.850654, -0.309011,
    0.162456, 0.850654, -0.499995
];

export default function createPath(array, error, steps)
{
    let errorAmount = array[0].clone().sub(array[1]).length() * error;

    for (let i=0; i < steps; i++)
    {
        let prev = array[0];
        const newArray = [ prev ];
        for (let j = 1; j < array.length; j++)
        {
            let curr = array[j];

            const idx = ((Math.random() * DIRECTIONS.length/3) | 0)*3;
            const vErr = new Vector3(
                DIRECTIONS[idx],
                DIRECTIONS[idx + 1],
                DIRECTIONS[idx+ 2]
            ).setLength( errorAmount/2 +  Math.random() * errorAmount/2);

            //console.log("ERR", vErr, idx);

            const mid = new Vector3(
                (curr.x + prev.x) / 2 + vErr.x,
                (curr.y + prev.y) / 2 + vErr.y,
                (curr.z + prev.z) / 2 + vErr.z,
            );

            newArray.push(mid, curr);
            prev = curr;
        }

        //console.log("new Array", newArray);
        array = newArray;
        errorAmount /= 2;
    }

    return array;
}
